import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenitalven: "",
    adminitalven: []
  },
  mutations: {
    login(state, data) {
      state.adminitalven = data.user;
      state.tokenitalven = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminitalven = [];
      state.tokenitalven = "";
    },
    adminitalven(state, data) {
      state.adminitalven = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminitalven", data);
    }
  }
});
